import { render, staticRenderFns } from "./MajorShareholdersDetailsHs.vue?vue&type=template&id=50e774f2"
import script from "./MajorShareholdersDetailsHs.vue?vue&type=script&lang=js"
export * from "./MajorShareholdersDetailsHs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports